/* SDJB AI Concierge widget. Talks to the Academy Storefront Concierge API.
   Keeps a session id in localStorage so the agent remembers the conversation. */
(function () {
  "use strict";

  var root = document.getElementById("sdjb-chat");
  if (!root) return;

  var cfg = window.SDJB_CHAT_CONFIG || {};
  var endpoint = cfg.endpoint || root.getAttribute("data-endpoint") || "";
  var welcome = cfg.welcome || "Hi, how can I help you today?";
  var customer = cfg.customer || null;

  var bubble = root.querySelector(".sdjb-chat__bubble");
  var panel = root.querySelector(".sdjb-chat__panel");
  var closeBtn = root.querySelector(".sdjb-chat__close");
  var form = root.querySelector(".sdjb-chat__form");
  var input = root.querySelector(".sdjb-chat__input");
  var messages = root.querySelector(".sdjb-chat__messages");

  var opened = false;
  var sending = false;

  function sessionId() {
    var key = "sdjb_chat_sid";
    var id = "";
    try {
      id = localStorage.getItem(key) || "";
    } catch (e) {}
    if (!id) {
      // The transcript is retrievable by this id alone, so it must be
      // unguessable: prefer crypto-strength randomness, fall back to the old
      // weaker format only where crypto is unavailable.
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        id = "web-" + window.crypto.randomUUID();
      } else {
        id = "web-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
      }
      try {
        localStorage.setItem(key, id);
      } catch (e) {}
    }
    return id;
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  // Minimal, safe markdown: escape first, then links + bold + line breaks.
  function render(text) {
    var html = escapeHtml(text);
    html = html.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, function (_m, label, url) {
      return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + label + "</a>";
    });
    html = html.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
    html = html.replace(/\n/g, "<br>");
    return html;
  }

  function addMessage(text, who) {
    var el = document.createElement("div");
    el.className = "sdjb-chat__msg sdjb-chat__msg--" + (who === "user" ? "user" : "bot");
    el.innerHTML = who === "user" ? escapeHtml(text) : render(text);
    messages.appendChild(el);
    messages.scrollTop = messages.scrollHeight;
    return el;
  }

  function showTyping() {
    var el = document.createElement("div");
    el.className = "sdjb-chat__typing";
    el.innerHTML = "<span></span><span></span><span></span>";
    messages.appendChild(el);
    messages.scrollTop = messages.scrollHeight;
    return el;
  }

  function welcomeText() {
    if (customer && customer.firstName) {
      return (
        "Welcome back, " +
        customer.firstName +
        "! How can I help you today? I can find a piece, or answer questions about selling, loans, hours, or shipping."
      );
    }
    return welcome;
  }

  // Restore a returning visitor's prior conversation from the server.
  async function loadHistory() {
    try {
      var res = await fetch(endpoint + "?sessionId=" + encodeURIComponent(sessionId()), {
        method: "GET",
        headers: { Accept: "application/json" },
      });
      var data = await res.json();
      if (data && Array.isArray(data.messages) && data.messages.length) {
        data.messages.forEach(function (m) {
          addMessage(m.content, m.role === "assistant" ? "bot" : "user");
        });
        return true;
      }
    } catch (e) {}
    return false;
  }

  async function open() {
    root.classList.add("is-open");
    bubble.setAttribute("aria-expanded", "true");
    panel.setAttribute("aria-hidden", "false");
    if (!opened) {
      opened = true;
      var restored = await loadHistory();
      if (!restored) addMessage(welcomeText(), "bot");
    }
    setTimeout(function () {
      input.focus();
    }, 200);
  }

  function close() {
    root.classList.remove("is-open");
    bubble.setAttribute("aria-expanded", "false");
    panel.setAttribute("aria-hidden", "true");
  }

  async function send(text) {
    if (!text || sending) return;
    sending = true;
    addMessage(text, "user");
    input.value = "";
    var typing = showTyping();

    try {
      var res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          sessionId: sessionId(),
          message: text,
          pageUrl: location.href,
          customer: customer || undefined,
        }),
      });
      var data = await res.json();
      typing.remove();
      addMessage(
        (data && data.reply) ||
          "Sorry, I had trouble with that. You can reach us at (619) 236-9603.",
        "bot"
      );
    } catch (e) {
      typing.remove();
      addMessage(
        "Sorry, I could not reach our concierge right now. Please call (619) 236-9603 and we will help.",
        "bot"
      );
    } finally {
      sending = false;
    }
  }

  bubble.addEventListener("click", open);
  closeBtn.addEventListener("click", close);
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    send(input.value.trim());
  });
})();
